import SvgIcon from '@mui/material/SvgIcon'
import { useRecordContext } from 'react-admin'

import CircularGaugeIcon from '../CircularGaugeIcon'
import FieldRow from './FieldRow'
import UnitField from '../UnitField'

const MileageIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
    >
      <line x1="7" y1="5" x2="7" y2="20" />
      <line x1="17" y1="5" x2="17" y2="20" />

      <line x1="12" y1="5.5" x2="12" y2="7.5" />
      <line x1="12" y1="11" x2="12" y2="13.5" />
      <line x1="12" y1="17" x2="12" y2="19.5" />
    </svg>
  </SvgIcon>
)

const MileageField = () => {
  const { mileage } = useRecordContext()
  return (
    <FieldRow
      icon={
        <CircularGaugeIcon
          Icon={MileageIcon}
          value={mileage}
          thresholds={[{ limit: Infinity, color: '#757575', label: 'mileage' }]}
        />
      }
    >
      <UnitField source="mileage" unit="km" />
    </FieldRow>
  )
}

export default MileageField
